import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '@/core/store/hooks'
import { cn } from '@bem-react/classname'

import { useHandleServerError } from '@/hooks/useHandleServerError'

import { Back } from '@/components/UI/Back'
import { Loading } from '@/components/UI/Loading'
import { Timer } from '@/components/UI/Timer'
import { Title } from '@/components/UI/Title'

import './OrderPayment.scss'
import { orderSelector } from './store/OrdersSelector'
import { getOrderThunk } from './store/OrdersSlice'

const cnOrderPayment = cn('OrderPayment')

export const OrderPayment: FC = () => {
  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { handleServerError } = useHandleServerError()

  const order = useAppSelector(orderSelector)

  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    if (id) getOrder(id)
  }, [id])

  const getOrder = async (id: string) => {
    try {
      await dispatch(getOrderThunk(id))
      setLoading(false)
    } catch (error) {
      handleServerError(error)
      setLoading(false)
    }
  }

  return (
    <>
      {isLoading ? (
        <Loading type='circle' minHeight='300px' />
      ) : (
        <>
          {order && (
            <div className={cnOrderPayment()}>
              <div className={cnOrderPayment('top')}>
                <Back />
                <Title>
                  {t('order-payment-title')} #{order.id}
                </Title>

                <Timer
                  end={order.cancel_timestamp}
                  className={cnOrderPayment('timer')}
                />
              </div>

              <div className={cnOrderPayment('grid')}>
                <div className={cnOrderPayment('item')}>
                  <div className={cnOrderPayment('value')}>
                    {parseFloat(order.sum_pay)} {order.from}
                  </div>
                  <div className={cnOrderPayment('label')}>
                    {t('order-label-5')}
                  </div>
                </div>
                <div className={cnOrderPayment('item')}>
                  <div className={cnOrderPayment('value')}>
                    {parseFloat(order.sum_buy)} {order.to}
                  </div>
                  <div className={cnOrderPayment('label')}>
                    {t('order-label-6')}
                  </div>
                </div>
              </div>

              <Title>{t('order-payment-subtitle')}</Title>
            </div>
          )}
        </>
      )}
    </>
  )
}
